/* Copyright (c) 2017 Backpack Health LLC */
/* global IS_ANDROID_BUILD */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';

import RouteNames from '../../appAuthorized/RouteNames';
import { selectors as userSelector } from '../../redux/ducks/user';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareAppNavStep, ScrollAwareContext, ScrollAwareScroller } from '../../components/ScrollAware';
import { AppHeaderScrollableTextWithLanguage } from '../../components/appNav/AppHeaderScrollable';
import { Subheading } from '../../components/Text';
import Card, { CardSection } from '../../components/card/Card';
import ContentWrapper from '../../components/ContentWrapper';

function mapStateToProps(state) {
  return {
    email: userSelector.getEmail(state),
  };
}

class CheckInboxSignup extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isFinished: false,
    };
  }

  render() {
    return this.state.isFinished ? <Redirect to={RouteNames.login()} /> : (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            submit={() => { this.setState({ isFinished: true }); }}
            submitDisabled={false}
            goBack={this.props.goBack}
            color="white"
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableTextWithLanguage
                id={this.props.title}
                allowLanguageToggle={!IS_ANDROID_BUILD}
              />
              <ContentWrapper>
                <Card>
                  <CardSection>
                    <div className="font-body" style={{ marginBottom: 14 }}>
                      {this.props.email}
                    </div>

                    <div className="font-subhead font-color-dark">
                      <FormattedMessage id={this.props.notification} />
                    </div>
                  </CardSection>
                </Card>

                <div className="util-application-frame-forcards-padding util-list-vertical-padding">
                  <Subheading color="neutral">
                    <FormattedMessage id="checkInbox.spam.message.text" />
                  </Subheading>
                </div>
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
CheckInboxSignup.propTypes = {
  email: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  notification: PropTypes.string.isRequired,
  goBack: PropTypes.func,
};

export default connect(mapStateToProps)(CheckInboxSignup);
